/**
 * This file is auto-generated from PatientProfileForm.loc.yaml
 * Do not edit this file directly. Edit the source file instead.
 */

import type { Translation } from '@nzyme/i18n-core';

export const title: Translation = lang => {
    switch (lang) {
        case 'en':
            return 'Profile';
        case 'pl':
            return 'Profil';
    }
};

export const subtitle: Translation = lang => {
    switch (lang) {
        case 'en':
            return 'Update your personal information';
        case 'pl':
            return 'Zaktualizuj swoje dane osobowe';
    }
};

export const saveButton: Translation = lang => {
    switch (lang) {
        case 'en':
            return 'Save changes';
        case 'pl':
            return 'Zapisz zmiany';
    }
};

export const errorSavingProfile: Translation = lang => {
    switch (lang) {
        case 'en':
            return 'Failed to save profile. Please try again.';
        case 'pl':
            return 'Nie udało się zapisać profilu. Spróbuj ponownie.';
    }
};

export const noPeselCheckbox: Translation = lang => {
    switch (lang) {
        case 'en':
            return "I don't have a PESEL number";
        case 'pl':
            return 'Nie mam numeru PESEL';
    }
};
